import { BaseLayoutFactory } from "../global/base-layout-factory";
import { ManagementUnitsProvider } from "./context/management-units-context";
import { ManagementUnitsComponent } from "./management-units-component";

export function ManagementUnitsFactory() {
    return (
        <BaseLayoutFactory>
            <ManagementUnitsProvider>
                <ManagementUnitsComponent />
            </ManagementUnitsProvider>
        </BaseLayoutFactory>
    );
}
